import React, { createContext, ReactNode, useContext } from 'react'
import { IShipment } from 'types'
import {
  getShipmentDetail,
  IGetShipmentDetailRequest,
} from 'apps/marketplace/utils/api/shipmentDetail'
import { useCallApi } from 'apps/marketplace/utils/hooks/useCallApi'

export interface IShipmentContextState {
  data?: IShipment
  errorMessage?: string
  hasError?: boolean
  isLoading: boolean
  load: (payload: IGetShipmentDetailRequest) => void
}

const defaultState: IShipmentContextState = {
  isLoading: false,
  load: () => {},
}

export const ShipmentContext = createContext(defaultState)

/**
 * Shipment Details Context Provider
 *
 * api: `/shipment/:shipmentId`
 * params: includes array - ShipmentIncludes[]
 */
export const ShipmentContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { data, errorMessage, hasError, isLoading, load } = useCallApi({
    apiCall: getShipmentDetail,
  })

  const state = {
    load,
    isLoading,
    data,
    hasError,
    errorMessage,
  }

  return <ShipmentContext.Provider value={state}>{children}</ShipmentContext.Provider>
}

/**
 * Shipment Details Context hook
 */
export const useShipmentContext = () => useContext<IShipmentContextState>(ShipmentContext)
